module.exports = __webpack_public_path__ + "static/StartBibles-b651e7c844f8354750d394296ed67f5d.jpeg";